import useConstant from 'use-constant';
export const _useLogic = ((...args) => {
    return useConstant(...args);
});
